import { useDefinedParams } from '@/hooks/useDefinedParams';
import { useUserInfo } from '@/hooks/useUserInfo';
import { EServiceLine, serviceLinesRequiringContractId } from '@/reducers/jbpGeneralSlice';
import { useAppSelector } from '@/store';
import { useEffect } from 'react';
import { useNavigate, Outlet } from 'react-router-dom';

export const SiteNavigationWrapper = ({ children }: React.PropsWithChildren) => {
  const [mpan, serviceLine] = useDefinedParams(['mpan', 'serviceLine']);
  const { isInternalUser, canAccess } = useUserInfo();
  const navigate = useNavigate();

  const { contractId } = useAppSelector(state => state.jbp);

  const requiresContractId = isInternalUser && serviceLinesRequiringContractId.includes(serviceLine as EServiceLine);

  useEffect(() => {
    if (contractId === undefined && requiresContractId) {
      if (canAccess('canViewContractSelect')) {
        navigate(`/contract/${mpan}/${serviceLine}`);
        return;
      }
      navigate('/');
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (requiresContractId && !contractId) return null;

  return (
    <>
      <Outlet />
      {children}
    </>
  );
};
